import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable() export class ConfirmDialogService {
  private subject = new Subject<any>();

  confirmThis(message: string, type='confirm', yesFn: () => void, noFn: () => void, edit:boolean = false, inactive:boolean = false): any {
    this.setConfirmation(message, type, yesFn, noFn, edit, inactive);
  }

  setConfirmation(message: string, type='confirm', yesFn: () => void, noFn: () => void, edit?: boolean, inactive?: boolean): any {
    const that = this;
    this.subject.next({
      inactive: inactive,
      edit: edit,
      type: type,
      text: message,
      yesFn(): any {
        that.subject.next(null); // This will close the modal
        yesFn();
      },
      noFn(): any {
        that.subject.next(null);
        noFn();
      }
    });

  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

}
